var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMarkerNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8878_21654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4009 21.0827C11.4009 21.0827 18.5673 15.3327 18.5673 9.10352C18.5673 5.13396 15.3588 1.91602 11.4009 1.91602C7.44291 1.91602 4.23438 5.13396 4.23438 9.10352C4.23438 15.3327 11.4009 21.0827 11.4009 21.0827Z",
    stroke: "#7B7B7B",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3978 11.9785C12.981 11.9785 14.2644 10.6913 14.2644 9.10352C14.2644 7.5157 12.981 6.22852 11.3978 6.22852C9.81467 6.22852 8.53125 7.5157 8.53125 9.10352C8.53125 10.6913 9.81467 11.9785 11.3978 11.9785Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.27344,
    y: 21.1328,
    width: 14.8753,
    height: 1.24324,
    fill: "#7B7B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8878_21654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerNew);
export default __webpack_public_path__ + "static/media/location-marker-new.6de4735222c6ef9324f33976e6ced45a.svg";
export { ForwardRef as ReactComponent };